<i18n
  src="@/locales/views/producer/reporting/liquidations/show_reports.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_processes')"
    :params="{ producer_id: producer_id }"
  />

  <template v-if="load_general_data">
    <bread-crumbs
      :labels="[
        module_name,
        `${agro_exporter_process.name} - ${agro_exporter_process.agro_exporter.name}`
      ]"
    />

    <div class="mt-6 px-4">
      <tabs-container v-model="option_tabs" :with_routing="true" />
    </div>

    <div v-if="show_reports">
      <router-view
        :summary="summary"
        :liquidations_monthly="liquidations_monthly"
        :totals_monthly="totals_monthly"
        :total_advances="total_advances"
        :crop_sizes="crop_sizes"
        :harvests_weekly="harvests_weekly"
        :totals_weekly="totals_weekly"
        :crop_size_labels="crop_size_labels"
        :crop_size_weekly="crop_size_weekly"
        :boxes_weekly="boxes_weekly"
        :kg_weekly="kg_weekly"
        :discarded_motives="discarded_motives"
      ></router-view>
    </div>
  </template>
</template>

<script>
import Requester from "@/views/producer/requesters/reporting/liquidations/show_reports.js";

export default {
  name: "PRODReportingLiquidationsShowReports",
  props: {
    producer_id: { required: true },
    agro_exporter_process_id: { required: true }
  },
  data() {
    return {
      option_tabs: [],
      load_general_data: false,
      load_data_summary: false,
      load_data_weekly: false,
      load_data_details: false,
      agro_exporter_process: {},
      harvested_batches: [],
      summary: {},
      liquidations_monthly: {},
      harvests_weekly: {},
      total_advances: 0,
      totals_monthly: {},
      totals_weekly: {},
      crop_size_labels: [],
      crop_size_weekly: {},
      boxes_weekly: {},
      kg_weekly: {},
      crop_sizes: {},
      discarded_motives: []
    };
  },
  computed: {
    show_reports: function () {
      const route_name = this.$route.name;
      if (
        (route_name == this.routeName("show_reports_summary") &&
          this.load_data_summary) ||
        (route_name == this.routeName("show_reports_weekly") &&
          this.load_data_weekly) ||
        route_name == this.routeName("show_reports_details")
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    loadData: async function () {
      this.fillOptions();
      await this.fetchAgroExporterProcess();
      this.loadDataReports();
      this.load_general_data = true;
    },
    loadDataReports: function () {
      if (this.option_tabs[0].current && !this.load_data_summary)
        this.loadDataSummary();
      if (this.option_tabs[1].current && !this.load_data_weekly)
        this.loadDataWeekly();
    },
    loadDataSummary: async function () {
      // await this.fetchSummary();
      // await this.fetchDiscardedMotives();
      await this.fetchHarvestsMonthly();
      await this.fetchTotalsMonthly();
      await this.fetchCropSizes();
      this.load_data_summary = true;
    },
    loadDataWeekly: async function () {
      // await this.fetchHarvestsWeekly();
      await this.fetchTotalsWeekly();
      await this.fetchCropSizeLabels();
      await this.fetchCropSizeWeekly();
      // await this.fetchBoxesWeekly();
      // await this.fetchKgWeekly();
      this.load_data_weekly = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchSummary: async function () {
      let response = await Requester.fetchSummary(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.summary = response.data;
    },
    fetchTotalAdvances: async function () {
      let response = await Requester.fetchTotalAdvances(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.total_advances = response.data;
    },
    fetchDiscardedMotives: async function () {
      let response = await Requester.fetchDiscardedMotives(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.discarded_motives = response.data;
    },
    fetchHarvestsMonthly: async function () {
      let response = await Requester.fetchHarvestsMonthly(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.liquidations_monthly = response.data;
    },
    fetchHarvestsWeekly: async function () {
      let response = await Requester.fetchHarvestsWeekly(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.harvests_weekly = response.data;
    },
    fetchTotalsMonthly: async function () {
      let response = await Requester.fetchTotalsMonthly(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.totals_monthly = response.data;
    },
    fetchTotalsWeekly: async function () {
      let response = await Requester.fetchTotalsWeekly(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.totals_weekly = response.data;
    },
    fetchCropSizeLabels: async function () {
      let response = await Requester.fetchCropSizeLabels(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.crop_size_labels = response.data;
    },
    fetchCropSizeWeekly: async function () {
      let response = await Requester.fetchCropSizeWeekly(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.crop_size_weekly = response.data;
    },
    fetchBoxesWeekly: async function () {
      let response = await Requester.fetchBoxesWeekly(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.boxes_weekly = response.data;
    },
    fetchKgWeekly: async function () {
      let response = await Requester.fetchKgWeekly(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.kg_weekly = response.data;
    },
    fetchCropSizes: async function () {
      let response = await Requester.fetchCropSizes(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.crop_sizes = response.data;
    },
    fetchHarvestedBatches: async function () {
      let response = await Requester.fetchHarvestedBatches(
        this.producer_id,
        this.agro_exporter_process_id
      );
      this.harvested_batches = response.data;
      this.fillPercentValues();
    },
    fillPercentValues() {
      this.harvested_batches.forEach(harvested_batch => {
        const discarded_percent = this.discardPercent(harvested_batch);
        harvested_batch["discarded_percent"] = discarded_percent;
        harvested_batch["ok_percent"] = 100 - discarded_percent;
      });
    },
    discardPercent(harvested_batch) {
      let percent =
        (Number(harvested_batch.discarded_weight) /
          Number(harvested_batch.total_weight)) *
        100;
      return Math.round(percent);
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.tabs.summary"),
          icon: "fa-solid fa-chart-pie",
          route: { name: this.routeName("show_reports_summary") },
          current: this.$route.name == this.routeName("show_reports_summary")
        },
        {
          name: this.$t("labels.tabs.weekly"),
          icon: "fa-solid fa-chart-line",
          route: { name: this.routeName("show_reports_weekly") },
          current: this.$route.name == this.routeName("show_reports_weekly")
        },
        {
          name: this.$t("labels.tabs.details"),
          icon: "fa-solid fa-list",
          route: { name: this.routeName("show_reports_details") },
          current: this.$route.name == this.routeName("show_reports_details")
        }
      ];
    }
  },
  watch: {
    option_tabs() {
      this.loadDataReports();
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          producer_id: this.producer_id
        }
      }).then(() => this.loadData())
    );
  }
};
</script>
